var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PublicityDetail8"},[_c('h3',[_vm._v("7.8全国保险公众宣传日丨爱和责任 保险让生活更美好")]),_c('img',{attrs:{"src":require('../images/ic_publicity_detail8_1.jpg')}}),_c('br'),_c('img',{attrs:{"src":require('../images/ic_publicity_detail8_2.jpg')}}),_c('br'),_c('img',{attrs:{"src":require('../images/ic_publicity_detail8_3.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }